var render = function () {
  var _vm$resume, _vm$resume$personalIn, _vm$resume$personalIn2, _vm$resume$personalIn3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 개인기본정보 ")]), _c('v-row', [_vm.mode != 'form' ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto rounded",
    attrs: {
      "aspect-ratio": 125 / 170,
      "width": "125",
      "src": _vm.profileSrc
    }
  }, [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.profileSrc,
      expression: "!profileSrc"
    }],
    attrs: {
      "absolute": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-image")])], 1)], 1)], 1)], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": ""
    }
  }, [_c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume,
      callback: function callback($$v) {
        _vm.resume = $$v;
      },
      expression: "resume"
    }
  }, 'vertical-form-table', {
    mode: _vm.mode,
    items: _vm.items
  }, false), [_c('template', {
    slot: "연락처"
  }, [_vm.mode == 'form' ? [_c('user-contact-certification', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'grey-6 white--text',
        className: 'w-80px w-lg-100px mt-n8'
      }
    },
    model: {
      value: _vm.resume.personalInformation.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.resume.personalInformation, "phone", $$v);
      },
      expression: "resume.personalInformation.phone"
    }
  })] : [_c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v(_vm._s((_vm$resume = _vm.resume) === null || _vm$resume === void 0 ? void 0 : (_vm$resume$personalIn = _vm$resume.personalInformation) === null || _vm$resume$personalIn === void 0 ? void 0 : (_vm$resume$personalIn2 = _vm$resume$personalIn.phone) === null || _vm$resume$personalIn2 === void 0 ? void 0 : (_vm$resume$personalIn3 = _vm$resume$personalIn2.phoneNumberFormat) === null || _vm$resume$personalIn3 === void 0 ? void 0 : _vm$resume$personalIn3.call(_vm$resume$personalIn2)))])]], 2)], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }